import { Component, OnInit, Input } from '@angular/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { CandidateCommentService } from '../../service/candidate-comment/candidate-comment.service';
import { CandidateComment } from '../../class/candidate-comment';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-candidate-comments',
  templateUrl: './candidate-comments.component.html',
  styleUrls: ['./candidate-comments.component.scss']
})
export class CandidateCommentsComponent implements OnInit {

    @Input() params_id_candidate: number;

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public candidateComments: CandidateComment[];
    public selectCandidateComment: CandidateComment;
    public CandidateCommentID: Number = 0;
    public modNew = false;
    public modView = false;
    public openCandidateComment = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public filters: any[];
    public first = 0;

    public form3: FormGroup;
    public created_by_id_filter: AbstractControl;
    public candidate_id_filter: AbstractControl;

    public typeOptions: SelectItem[];

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public f4_created_by_id: AbstractControl;
    public f4_candidate_id: AbstractControl;

    public f4_export_filter: AbstractControl;

    public apiUrl = config.API_ROOT;

    public modExportDialog: boolean;

    public es: any;
    public showFilter: boolean;

    public exportOptions: SelectItem[];

    constructor(
        public candidateCommentService: CandidateCommentService,
        public hasPermissionService: HasPermissionService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        public activatedRoute: ActivatedRoute,

        fb: FormBuilder) {
            this.exportOptions = [
                {label: 'Excel', value: 'excel'},
            ];

            this.es = calendarES();

            this.typeOptions = [
                {label: 'Todas', value: 'all'},
                {label: 'Novedad', value: 'Novedad'},
                {label: 'Tarea', value: 'Tarea'},
                {label: 'Trámite', value: 'Trámite'},
                {label: 'Nota', value: 'Nota'},
            ];

            this.form3 = fb.group({
                'created_by_id_filter': [''],
                'candidate_id_filter': [''],
            });
            this.created_by_id_filter = this.form3.controls['created_by_id_filter'];
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
                'f4_created_by_id': [''],
                'f4_candidate_id': [''],
                'f4_export_filter': [''],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];
            this.f4_created_by_id = this.form4.controls['f4_created_by_id'];
            this.f4_candidate_id = this.form4.controls['f4_candidate_id'];
            this.f4_export_filter = this.form4.controls['f4_export_filter'];
            this.f4_export_filter.setValue('excel');

            this.modExportDialog = false;
        }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_candidate']) {
                this.params_id_candidate = Number(params['id_candidate']);
            }
        });

        this.page = 1;
        this.per_page = 10;
        // if (this.params_id_candidate) {
        //     this.getCandidateCommentsByCandidates(this.params_id_candidate);
        //     this.showFilter = false;
        // } else {
        //     this.getCandidateComment();
        //     this.showFilter = true;
        // }
    }

    public loadCandidateCommentsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  event.sortField;
        } else {
            this.sort =  '-id';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        if (this.params_id_candidate) {
            this.getCandidateCommentsByCandidates(this.params_id_candidate,event.globalFilter);
        } else {
            this.getCandidateComment(event.globalFilter);
        }
            // this.getCandidateComment(event.globalFilter);
        
    }

    public getCandidateComment(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.candidateCommentService.getCandidateComment(this.page, this.per_page, this.sort, this.query, filters).toPromise().then(
            response => {
                this.candidateComments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getCandidateCommentsByCandidates(id: number, query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.candidateCommentService.getCandidateCommentByRequisition(id, this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.candidateComments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newCandidateComment() {
        this.modNew = !this.modNew;
        this.selectCandidateComment = null;
    }

    public savedCandidateComment(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectCandidateComment = null;
        this.modNew = false;
        this.getCandidateComment();
    }

    public cancelCandidateComment (res) {
        this.selectCandidateComment = null;
        this.modNew = false;
        this.modView = false;
        this.getCandidateComment();
    }

    public edit(candidateComment: CandidateComment) {
        this.modNew = true;
        this.selectCandidateComment = candidateComment;
        this.getCandidateComment();
    }

    public view(candidateComment: CandidateComment) {
        this.openCandidateComment = true;
        this.selectCandidateComment = candidateComment;
        this.CandidateCommentID = candidateComment.id;
        this.modView = true;
    }

    public deleteDialog(candidateComment: CandidateComment) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(candidateComment);
            }
        });
    }

    public delete(candidateComment: CandidateComment) {
        this.candidateCommentService.deleteCandidateComment(candidateComment.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getCandidateComment();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeCandidateComment(candidateComment: CandidateComment) {
        this.putCandidateComment(candidateComment);
    }

    public putCandidateComment(values: CandidateComment) {
        const param = {
            'observations': values.observations,
        };
        if (values) {
            const promise = this.candidateCommentService.updateCandidateComment(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filterStation (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (values.created_by_id_filter) {
            this.filters.push({'key': 'created_by_id-lk', 'value': values.created_by_id_filter.id});
        }

        if (this.params_id_candidate ) {
            this.filters.push({'key': 'candidate_id-lk', 'value': values.params_id_candidate});
        }
        if(values.candidate_id_filter)
            this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});
        // if (this.params_id_candidate || values.candidate_id_filter) {
        //     let id = this.params_id_candidate;
        //     if (values.candidate_id_filter) {
        //         if (values.candidate_id_filter.id) {
        //             id = values.candidate_id_filter.id;
        //         }
        //     }
        //     this.getCandidateCommentsByCandidates(id, undefined, this.filters);
        // } else {
        //     this.getCandidateComment(undefined, this.filters);
        // }
        this.getCandidateComment(undefined, this.filters);
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportPdf(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        window.open(this.apiUrl + '/candidate-comments/pdf?created_at-min=' + f4_date_start + '&created_at-max=' + f4_date_end +
        '&token=' + localStorage.getItem('token') + '&_page=1&_limit=100000', '_blank');
    }

    public exportReport(values) {
        if (values.f4_export_filter === 'pdf') {
            this.exportReportPdf(values);
        } else {
            this.exportReportExcel(values);
        }
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/candidate-comments/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=-id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        if (values.f4_created_by_id) {
            url = url + 'created_by_id-in=' + values.f4_created_by_id.id + '&';
        }

        if (values.f4_candidate_id) {
            url = url + 'candidate_id-in=' + values.f4_candidate_id.id + '&';
        }


        window.open(url, '_blank');
    }
    
    isImage(content: any): boolean {
        return typeof content === 'string' && content.includes('<p><img src="data:image/png;base64,');
    }
    
    extractImageUrl(content: any): string | null {
        if (typeof content !== 'string') {
            return null;
        }
        const match = content.match(/<p><img src="([^"]+)"/);
        return match ? match[1] : null;
    }
    stripHtml(html: string): string {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidate-comments/candidate-comments.component.ts